/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { shape, string, func, bool } from "prop-types";
import { connect } from "react-redux";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as transactionsActions } from "reducers/transactions";
import I18n from "pages/_components/I18n";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import * as configUtils from "util/config";
import * as i18nUtils from "util/i18n";
import { truncateWithEllipsis } from "util/string";
import Card from "pages/_components/Card/Card";
import Image from "pages/_components/Image";
import InfoTag from "pages/_components/InfoTag";
import ContextMenu from "pages/_components/ContextMenu";
import { getMultipleTransfersI18nKey } from "util/multiple-transfers";
import { Box } from "@ui-kit/components/index.es";
import { getTransferActivityName } from "util/transferInternalTitleLabels";

const externalActivities = [
    "external.emit.echeq.activity",
    "external.emit.massive.echeq.activity",
    "send.external.transaction",
];
const isExternalChannelTransaction = (idActivity, data, channel) =>
    externalActivities.includes(idActivity) || data?.externalChannel === true || channel === "externo";
const getFirstNotBlank = (...values) => values.find((value) => typeof value === "string" && value.trim().length > 0);
const stripTrailingColon = (value = "") => value.replace(/:\s*$/, "");

const getEcomexBeneficiaryName = (data = {}) => {
    const transactionData = data?.transactionData || {};
    return getFirstNotBlank(
        transactionData?.beneficiaryName,
        transactionData?.nombreBeneficiario,
        data?.beneficiaryName,
        data?.nombreBeneficiario,
    );
};

class TransactionsItem extends Component {
    static propTypes = {
        transaction: shape({
            cancelEnabled: string.isRequired,
            transaction: shape({
                creationDateTime: string,
                submitDateTime: string,
                activityName: string,
                idTransactionStatus: string,
            }),
            transactionAmounts: shape(),
        }).isRequired,
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
    };

    renderContexMenu = ({ idTransaction }) => {
        const { dispatch, isDesktop } = this.props;
        const items = [
            {
                label: "transactions.list.actions.delete",
                onClick: () => {
                    dispatch(transactionsActions.deleteDraftRequest(idTransaction));
                },
            },
        ];
        return (
            <ContextMenu
                items={items}
                isDesktop={isDesktop}
                imageDropdown="context-menu-black.svg"
                additionalClasses="btn btn-link btn-dropdown"
                dropBtnClass="p-0 m-0"
            />
        );
    };

    render() {
        const { transaction: propsTransaction, isDesktop } = this.props;
        const { transaction, transactionAmounts } = propsTransaction;
        const {
            creationDateTime,
            submitDateTime,
            activityName: rawActivityName,
            idTransactionStatus,
            draftTransaction,
            data,
            idActivity,
        } = transaction;
        const activityName = getTransferActivityName(idActivity, rawActivityName);
        const currency =
            activityName === "CREDIN" && draftTransaction && data.cbuList?.length
                ? data.cbuList[0].amount.currency
                : Object.keys(transactionAmounts)[0];
        const amount =
            activityName === "CREDIN" && draftTransaction
                ? data.cbuList?.reduce((acc, val) => val.amount.quantity + acc, 0)
                : transactionAmounts[currency];
        let showAmount = amount !== 0;

        const enableNonDeductLimits = configUtils.getBoolean("frontend.ecomex.check.nonDeduct.limits", false);
        const showEcomexAdditionalData = configUtils.getBoolean("frotend.show.divisa.amount.Ecomex");
        const showBeneficiaryEcomex = configUtils.getBoolean("frontend.show.beneficiary.ecomex", false);
        const beneficiaryMaxLength = configUtils.getInteger("frontend.show.beneficiary.ecomex.maxLength", 100);
        const ecomexBeneficiaryName = getEcomexBeneficiaryName(transaction?.data);
        const ecomexBeneficiaryNameToShow = truncateWithEllipsis(ecomexBeneficiaryName, beneficiaryMaxLength);
        const ecomexBeneficiaryLabel = i18nUtils.get("ecomex.transaction.card.beneficiaryName");
        const showEcomexBeneficiary =
            activityName === "Comercio Exterior" && showBeneficiaryEcomex && !!ecomexBeneficiaryNameToShow;
        let montoEcomex;
        if (activityName === "Comercio Exterior") {
            montoEcomex = new Intl.NumberFormat("es-AR", {
                style: "currency",
                currency: transaction?.data?.transactionData?.requestCurrency,
                currencyDisplay: "code",
            }).format(transaction?.data?.transactionData?.requestAmount);
            if (enableNonDeductLimits && !showEcomexAdditionalData) {
                showAmount = true;
            } else {
                showAmount = false;
            }
        }

        return (
            <>
                {isDesktop ? (
                    <Card
                        className="card__transaction"
                        iconWithText={
                            <div className="d-flex flex-column min-width-3">
                                <Image src={`images/transfer-${idTransactionStatus}.svg`} />
                                <I18n
                                    componentProps={{ className: `transaction-status-text-${idTransactionStatus}` }}
                                    id={`transaction.status.${idTransactionStatus}`}
                                />
                            </div>
                        }
                        rightArrow={idTransactionStatus !== "DRAFT"}
                        rightContextMenu={idTransactionStatus === "DRAFT" && this.renderContexMenu(transaction)}
                        title={
                            <div className="card__transaction-data-title">
                                <div className="d-flex">
                                    <I18n
                                        componentProps={{ className: "card__transaction-data-title-left" }}
                                        id="transactions.list.item.PENDING"
                                    />
                                    <FormattedDate
                                        className="card__transaction-data-time-left"
                                        showTime
                                        date={submitDateTime}
                                    />
                                    <I18n
                                        componentProps={{ className: "card__transaction-data-title-right" }}
                                        id="transactions.list.header.creationDate"
                                    />
                                    <FormattedDate
                                        className="card__transaction-data-time-rigth"
                                        showTime
                                        date={creationDateTime}
                                    />
                                </div>
                            </div>
                        }
                        content={
                            <div className="card__transaction-data-description">
                                {activityName === "Comercio Exterior" && showEcomexAdditionalData ? (
                                    <Box flex column>
                                        <div className="card__transaction-ecomex-row">
                                            <span className="card__transaction-ecomex-concept">
                                                {activityName} | {transaction?.data?.transactionData?.concept}
                                            </span>
                                            <div className="echeqs__cards-content card__transaction-ecomex-amount">
                                                <span className="echeqs__type">{montoEcomex}</span>
                                            </div>
                                        </div>

                                        {showEcomexBeneficiary && (
                                            <span>
                                                <strong>
                                                    {ecomexBeneficiaryLabel} {ecomexBeneficiaryNameToShow}
                                                </strong>
                                            </span>
                                        )}
                                    </Box>
                                ) : null}
                                {activityName === "Comercio Exterior" && !showEcomexAdditionalData ? (
                                    <Box flex column>
                                        <span>{activityName}</span>
                                        {showEcomexBeneficiary && (
                                            <span>
                                                <strong>
                                                    {ecomexBeneficiaryLabel} {ecomexBeneficiaryNameToShow}
                                                </strong>
                                            </span>
                                        )}
                                    </Box>
                                ) : null}
                                {idActivity === "transfer.multiple.send" && (
                                    <I18n id={getMultipleTransfersI18nKey("activities.transfer.multiple.send")} />
                                )}
                                {activityName === "Descontar ECHEQs" ? (
                                    <I18n id="echeqs.transaction.negotiate.label" />
                                ) : null}
                                {activityName === "Emitir Cesión" && activityName !== "Descontar ECHEQs" ? (
                                    <I18n id="echeqs.transaction.cesion.label" />
                                ) : null}
                                {activityName !== "Descontar ECHEQs" &&
                                activityName !== "Emitir Cesión" &&
                                activityName !== "Comercio Exterior" &&
                                idActivity !== "transfer.multiple.send" ? (
                                    <span>{activityName}</span>
                                ) : null}
                                {isExternalChannelTransaction(idActivity, data, transaction?.channel) && (
                                    <InfoTag
                                        type="default"
                                        message={i18nUtils.get("transactions.list.external.label", "Canal externo")}
                                        tagClass="external-channel-tag"
                                        capitalize
                                    />
                                )}
                            </div>
                        }
                        rightContent={
                            <div className="card__component-item-currency d-flex align-items-center">
                                {showAmount && (
                                    <FormattedAmount
                                        {...(idTransactionStatus === "DRAFT" && {
                                            className: "data-amount-gray-color",
                                        })}
                                        currency={currency}
                                        quantity={amount}
                                    />
                                )}
                            </div>
                        }
                    />
                ) : (
                    <Card
                        className="card__transaction"
                        rightArrow={idTransactionStatus !== "DRAFT"}
                        iconWithText={
                            <div className="d-flex flex-column card__transaction-mobile-icon-col">
                                <div className="d-flex">
                                    {idTransactionStatus ? (
                                        <Image src={`images/transfer-${idTransactionStatus}.svg`} />
                                    ) : null}
                                    <I18n
                                        componentProps={{ className: `transaction-status-text-${idTransactionStatus}` }}
                                        id={`transaction.status.${idTransactionStatus}`}
                                    />
                                </div>
                                {showEcomexAdditionalData && activityName === "Comercio Exterior" ? (
                                    <I18n
                                        componentProps={{ className: "card__transaction-data-title-left mt-4" }}
                                        id="transactions.list.item.PENDING"
                                    />
                                ) : null}
                                {!showEcomexAdditionalData && activityName === "Comercio Exterior" ? (
                                    <I18n
                                        componentProps={{ className: "card__transaction-data-title-left mt-2" }}
                                        id="transactions.list.item.PENDING"
                                    />
                                ) : null}
                                {activityName !== "Comercio Exterior" ? (
                                    <I18n
                                        componentProps={{ className: "card__transaction-data-title-left mt-2" }}
                                        id="transactions.list.item.PENDING"
                                    />
                                ) : null}
                                <I18n
                                    componentProps={{ className: "card__transaction-data-title-right" }}
                                    id="transactions.list.header.creationDate"
                                />
                                {showEcomexAdditionalData && activityName === "Comercio Exterior" ? (
                                    <span className="card__transaction-data-title-right">
                                        {i18nUtils.get("ecomex.transaction.data.requestCurrency")}/
                                        {i18nUtils.get("ecomex.transaction.data.requestAmount")}
                                    </span>
                                ) : null}
                            </div>
                        }
                        content={
                            <div className="card__transaction-data-description">
                                <div className="d-flex flex-column card__transaction-mobile-main">
                                    <div>
                                        {showEcomexAdditionalData && activityName === "Comercio Exterior" ? (
                                            <span className="card__transaction-ecomex-concept">
                                                {activityName}|{" "}
                                                {transaction?.data?.transactionData?.concept.trim().length > 35
                                                    ? `${transaction?.data?.transactionData?.concept
                                                          .trim()
                                                          .substring(0, 32)}...`
                                                    : transaction?.data?.transactionData?.concept.trim()}
                                            </span>
                                        ) : null}
                                        {!showEcomexAdditionalData && activityName === "Comercio Exterior" ? (
                                            <span className="card__transaction-mobile-activity-title">
                                                {activityName}
                                            </span>
                                        ) : null}
                                        {activityName !== "Comercio Exterior" ? (
                                            <span className="card__transaction-mobile-activity-title">
                                                {activityName}
                                            </span>
                                        ) : null}
                                        {isExternalChannelTransaction(idActivity, data, transaction?.channel) && (
                                            <InfoTag
                                                type="default"
                                                message={i18nUtils.get(
                                                    "transactions.list.external.label",
                                                    "Canal externo",
                                                )}
                                                tagClass="external-channel-tag"
                                                capitalize
                                            />
                                        )}
                                        {idTransactionStatus === "DRAFT" && this.renderContexMenu(transaction)}
                                    </div>
                                    {showEcomexAdditionalData && activityName === "Comercio Exterior" ? (
                                        <div className="d-flex flex-column align-items-end card__transaction-mobile-dates">
                                            <FormattedDate
                                                className="card__transaction-data-time-left"
                                                showTime
                                                date={submitDateTime}
                                            />
                                            <FormattedDate
                                                className="card__transaction-data-time-rigth"
                                                showTime
                                                date={creationDateTime}
                                            />
                                            <p className="text-lead mt-0 mb-0 text-nowrap">{montoEcomex}</p>
                                        </div>
                                    ) : null}
                                    {!showEcomexAdditionalData && activityName === "Comercio Exterior" ? (
                                        <div className="d-flex flex-column align-items-end card__transaction-mobile-dates">
                                            <FormattedDate
                                                className="card__transaction-data-time-left"
                                                showTime
                                                date={submitDateTime}
                                            />
                                            <FormattedDate
                                                className="card__transaction-data-time-rigth"
                                                showTime
                                                date={creationDateTime}
                                            />
                                        </div>
                                    ) : null}
                                    {activityName !== "Comercio Exterior" ? (
                                        <div className="d-flex flex-column align-items-end card__transaction-mobile-dates">
                                            <FormattedDate
                                                className="card__transaction-data-time-left"
                                                showTime
                                                date={submitDateTime}
                                            />
                                            <FormattedDate
                                                className="card__transaction-data-time-rigth"
                                                showTime
                                                date={creationDateTime}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        }
                        mobileBottom={
                            showEcomexBeneficiary && activityName === "Comercio Exterior" ? (
                                <span className="card__transaction-beneficiary-mobile">
                                    {stripTrailingColon(ecomexBeneficiaryLabel)}: {ecomexBeneficiaryNameToShow}
                                </span>
                            ) : null
                        }
                        rightContent={
                            <div className="card__component-item-currency">
                                {showAmount && <FormattedAmount currency={currency} quantity={amount} />}
                            </div>
                        }
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(TransactionsItem);
